import React from 'react'

const Middle = () => {
  return (
    <>
      <div className="middle_container">
        <div className="subset_middle">
          <div className="navigation_detail_div">
            <p>UI/UX > Refer & Earn</p>
          </div>

          <div className="referral_div_parent">

            <div className="total_referral_wallet">
              <div className="inner_container_trw">
                <div className="referral_earning_div">
                  <p>Referral Earning</p>
                  <h1>₹ 2,500</h1>
                </div>

                <div className="referral_earning_div">
                  <p>Total Referrals</p>
                  <h1>7</h1>
                </div>
                <div className="referral_earning_div">
                  <p>Wallet Balance</p>
                  <h1>₹ 500</h1>
                </div>
              </div>

              <div className="withdraw_div">
                <div className="withdraw_inner">
                  <p>Withdraw Balance</p>
                </div>
              </div>

            </div>
            <div className="code_refer_2">
              <div className="your_referral_code_div">
                <h3>Your Referral Code</h3>

              </div>

              <div className="referal_code_value" >

                <span>E</span>
                <span>D</span>
                <span>C</span>
                <span>H</span>
                <span>5</span>
                <span>4</span>

              </div>
            </div>

          </div>

          <div className="middle_deatils">
            <div className="how_does_div">
              <h2>How does it work ?</h2>

            </div>

            <div className="extra_detail_div">
              <div className="icon_detail_div">
                <i class="fa-solid fa-users icons"></i>

                <div className="written_detail">
                  <p>Invite your Friends</p>
                  <p>Share the link tutedude.com with your friends</p>

                </div>

              </div>
              <div className="icon_detail_div">
                <i class="fa-sharp fa-solid fa-tag icons"></i>

                <div className="written_detail">
                  <p>Invite your Friends</p>
                  <p>Share the link tutedude.com with your friends</p>

                </div>

              </div>
              <div className="icon_detail_div">
                <i class="fa-solid fa-indian-rupee-sign rupe-icons" ></i>

                <div className="written_detail">
                  <p>Invite your Friends</p>
                  <p>Share the link tutedude.com with your friends</p>

                </div>

              </div>
              <div className="icon_detail_div">
                <i class="fa-brands fa-discourse icons"></i>

                <div className="written_detail">
                  <p>Invite your Friends</p>
                  <p>Share the link tutedude.com with your friends</p>

                </div>

              </div>
              <div className="icon_detail_div">
                <i class="fa-solid fa-wallet icons"></i>

                <div className="written_detail">
                  <p>Invite your Friends</p>
                  <p>Share the link tutedude.com with your friends</p>

                </div>

              </div>

            </div>
          </div>

          <div className="frnd_who_enroll_t_c">

            <div className="frnd_who_enroll">
              <p>Friends Who Enrolled</p>
            </div>

            <div className="t_c_div">
              <p>Terms & Conditions</p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Middle
